/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { createColumnHelper } from '@tanstack/react-table';
import { formatDate, formatTime, resolveBadgeTypeForStatus, resolveInvoiceBadgeType } from 'src/utils/general';
import Badge from 'src/components/ui/Badge/Badge';
import AddOnsCard from 'src/components/cardLayouts/AddOnsCard/AddOnsCard';
import RadioButtonControl from '../../ui/RadioButtonControl/RadioButtonControl';
import Input from '../../ui/Input/Input';
import Button, { ButtonPositionProps, ButtonToneProps } from '../../ui/Button/Button';
import Tooltip from '../../ui/Tooltip/Tooltip';
import Divider from '../../ui/Divider/Divider';

const columnHelper = createColumnHelper<any>();
interface ColumnHelperProps {
  t: TFunction;
}

export interface AddOnsBillingProps {
  hasWriteAccess?: boolean;
}

const AddOnsBilling = ({ hasWriteAccess }: AddOnsBillingProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col w-full gap-[24px] md:gap-[32px]">
      <div className="flex flex-col w-full items-start gap-8 mt-[32px]">
        <span className="typo-title-24">{t('add_ons_billing.title')}</span>
        <p className="typo-text-12 text-faded">{t('add_ons_billing.description')}</p>
      </div>
      <div className="flex flex-col gap-12">
        <AddOnsCard
          title={t('add_ons_billing.starter')}
          description={t('add_ons_billing.starter_description')}
          price="19,90€"
          url="#"
          billingCycle="month"
          active
        />
        <AddOnsCard
          title={t('add_ons_billing.basic')}
          description={t('add_ons_billing.basic_description')}
          icon="company"
          price="19,90€"
          url="#"
        />
      </div>

      <div className="flex flex-col gap-2">
        <span className="typo-text-16--bold">{t('add_ons_billing.payment_details')}</span>
        <p className="typo-text-12 text-faded">{t('add_ons_billing.payment_details_description')}</p>
      </div>

      <div className="flex flex-col gap-12">
        <div className="flex justify-between items-center p-20 rounded-base border-subtle">
          <div className="flex flex-col gap-2">
            <p className="typo-text-16--bold mb-4">{t('add_ons_billing.company_details')}</p>
            <p className="typo-text-12 text-faded">Weship Fulfillment GmbH</p>
            <p className="typo-text-12 text-faded">manuel.wagner@weship.com</p>
          </div>
          <Button
            title={t('add_ons_billing.edit')}
            tone={ButtonToneProps.PRIMARY_BLUE}
            onClick={() => console.log('add ons')}
          />
        </div>

        <div className="flex justify-between items-center p-20 rounded-base border-subtle">
          <div className="flex flex-col gap-2">
            <p className="typo-text-16--bold mb-4">{t('add_ons_billing.payment_method')}</p>
            <p className="typo-text-12 text-faded">Visa ending in 1234</p>
          </div>
          <Button
            title={t('add_ons_billing.edit')}
            tone={ButtonToneProps.PRIMARY_BLUE}
            onClick={() => console.log('add ons')}
          />
        </div>
      </div>

      <div className="flex flex-col gap-[32px] w-full">
        <Divider />
        <div className="flex justify-between items-center">
          <span className="typo-text-16--bold">{t('add_ons_billing.invoices')}</span>
          <a className="flex items-center gap-6 cursor-pointer" href="/">
            <span className="text-primary typo-text-14--bold">{t('fulfillment_billing.see_all_invoices')}</span>
            <img src="/arrow-link.svg" alt="arrow" width={10} height={10} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AddOnsBilling;
